<script setup>
import {defineProps} from 'vue'
import ProviderThumbnail from '@/components/Anonymization/ProviderThumbnail.vue'

const props = defineProps(["data"])
</script>

<template>
  <div class="d-flex vertically-centered">
    <template v-if="props.data && props.data.services && props.data.services.length > 0">
      <ProviderThumbnail
        :data="{
          name: props.data.services[0].display_name || props.data.services[0].provider,
          thumbnail_url: props.data.services[0].thumbnail_url
        }"
        class="me-2"
      />
      <span>{{ props.data.services[0].display_name || props.data.services[0].provider }}</span>
      <span v-if="props.data.services.length > 1" class="text-muted ms-1">
        (+{{ props.data.services.length - 1 }} more)
      </span>
    </template>
    <span v-else-if="props.data && props.data.tor">Tor</span>
    <span v-else-if="props.data && props.data.vpn">VPN (unknown service)</span>
    <span v-else-if="props.data && props.data.proxy">Proxy (unknown service)</span>
  </div>
</template>

<style scoped>
/* Scale down thumbnail to match table size */
:deep(.provider-thumbnail-container) {
  width: 16px;
  height: 16px;
}

:deep(.provider-thumbnail),
:deep(.provider-thumbnail-image) {
  width: 16px;
  height: 16px;
  font-size: 0.6rem;
}
</style>
